import { type ProfileChangeLog } from "@clipboard-health/contract-backend-main";
import { Alert, Box, CircularProgress, Stack } from "@mui/material";

import { ProfileChangeLogsTable } from "./ProfileChangeLogsTable";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";

interface ProfileChangeLogsModalContentProps {
  isError: boolean;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  isFiltered: boolean;
  hasNextPage: boolean;
  logs: ProfileChangeLog[];
  onLoadMore: () => void;
}

export function ProfileChangeLogsModalContent(props: ProfileChangeLogsModalContentProps) {
  const { isError, isLoading, isFetchingNextPage, isFiltered, hasNextPage, logs, onLoadMore } =
    props;

  if (isError) {
    return (
      <Alert severity="error">
        There was an error loading profile change logs. Please try again later.
      </Alert>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ flex: 1, display: "grid", placeItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (logs.length === 0) {
    return (
      <Box sx={{ flex: 1, display: "grid", placeItems: "center", color: "text.secondary" }}>
        {isFiltered ? "No logs match the current filters." : "No profile change logs yet."}
      </Box>
    );
  }

  return (
    <Stack direction="column" spacing={2} sx={{ flex: 1, minHeight: 0 }}>
      <ProfileChangeLogsTable logs={logs} />
      {hasNextPage && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <LoadingButton
            variant="outlined"
            isLoading={isFetchingNextPage}
            onClick={onLoadMore}
            sx={{ width: 100 }}
          >
            Load more
          </LoadingButton>
        </Box>
      )}
    </Stack>
  );
}
